// src/layout/DashboardLayout.jsx
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar"; // tu sidebar aquí

const { Content } = Layout;

export default function DashboardLayout() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout>
        <Content style={{ padding: 24, background: "#f5f7fa" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
